module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/WhichPlanSection/third-party-liability-6adffdc0be6ff9ecd2e1eaaf8a2b46bd.png";